// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_86q","cls2":"PodcastPlayer-cls2_t5m PodcastPlayer-cls1_86q"};